module.exports = __webpack_public_path__ + "fonts/Clash-Regular.f37da98.otf";